import { API } from 'api';
import { AxiosResponse } from 'axios';
import { IPayInRefundRequest, IPaymentListRequest } from "types/payment.interface";
import { API_URL } from 'utils/enums';

class PaymentService {
    static getPaymentList = async (reqBody: IPaymentListRequest): Promise<AxiosResponse> =>
        API.post(API_URL.PAYMENT_LIST_GET, reqBody);

    static getPaymentBillInfo = async (billId: string): Promise<AxiosResponse> =>
        API.post(API_URL.PAYMENT_BILL_INFO, { billId });

    static getPaymentBillLogInfo = async (paymentId: string): Promise<AxiosResponse> =>
        API.post(API_URL.PAYMENT_BILL_LOG_INFO, { paymentId });

    static payInRefund = async (reqBody: IPayInRefundRequest): Promise<AxiosResponse> =>
        API.post(API_URL.PAY_IN_REFUND, reqBody);
}

export { PaymentService };
